import { registerAppLinks } from "@shared/services/appLinkRegistry";

registerAppLinks([
  {
    uriExpression: "twin-edit.sfw.asset.*",
    routeName: "sfwAssetDetail",
  },
  {
    uriExpression: "twin-edit.sfw.ticket.walk",
    routeName: "sfwOrderHistoryDetail",
  },
  {
    uriExpression: "twin-edit.sfw.ticket.*",
    routeName: "sfwTicketDetail",
  },
]);
